import { NextBestActionDefinitionAction, NextBestActionType } from "./nextBestActionDefinition";

type NextBestActionTypesWithChildren = NextBestActionType.HOST_DEFAULT | NextBestActionType.HOST_TEXT;

type NextBestActionTypesWithLayout = NextBestActionType.HOST_DEFAULT;

const nextBestActionDefinitionHasChildren = (
  action: NextBestActionDefinitionAction,
): action is NextBestActionDefinitionAction<NextBestActionTypesWithChildren> =>
  [NextBestActionType.HOST_DEFAULT, NextBestActionType.HOST_TEXT].includes(action.type);

const nextBestActionDefinitionHasLayout = (
  action: NextBestActionDefinitionAction,
): action is NextBestActionDefinitionAction<NextBestActionTypesWithLayout> =>
  [NextBestActionType.HOST_DEFAULT].includes(action.type);

const isCardAction = (
  action: NextBestActionDefinitionAction,
): action is NextBestActionDefinitionAction<NextBestActionType.CARD> => action.type === NextBestActionType.CARD;

const isHostDefaultAction = (
  action: NextBestActionDefinitionAction,
): action is NextBestActionDefinitionAction<NextBestActionType.HOST_DEFAULT> =>
  action.type === NextBestActionType.HOST_DEFAULT;

export type { NextBestActionTypesWithChildren, NextBestActionTypesWithLayout };
export { nextBestActionDefinitionHasChildren, nextBestActionDefinitionHasLayout, isCardAction, isHostDefaultAction };
